import React, {PureComponent} from "react";
import {Alert} from "reactstrap";
import {map} from "lodash";

class OrderErrors extends PureComponent {
  render() {
    const {validationErrors} = this.props;
    return (
      <div className="mt-2">
        {map(validationErrors, (value, key) => (
          <Alert key={key} color="danger">{value}</Alert>
        ))}
      </div>
    );
  }
}

export default OrderErrors;